export default __webpack_public_path__ + "static/media/40c095235fd4d332afe94dd7f7d8ed35.svg";